import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('receiptBatchReport', [booksMenu])
  .controller('receiptBatchReportCtrl', receiptBatchReportCtrl)
  .name;
  
/* @ngInject */ function receiptBatchReportCtrl($scope, BooksSvc, SERVER, BusyScreen) {
  /*----------------------------*/
  /* set up form default values */
  /*----------------------------*/
  $scope.data = {};
  $scope.req = { reportFormat: 'PDF' };

  /*--------------------------------------*/
  /* Watches the data.user model and sets */
  /* it to 0 if there is no req.loginID   */
  /*--------------------------------------*/
  $scope.$watch('data.user', function (user) {
    $scope.req.loginID = user ? user.id : 0;
  });

  /*****************************************************************************
   * checkGroup */
  /**
   * Verifies that there is a valid name in the Receipt Recorder typeahead. If
   * not, the text is cleared on blur.
   *****************************************************************************/
  $scope.checkGroup = function () {
    if (!$scope.req.loginID) {
      $scope.data.user = '';
    }
  };

  /*------------------------*/
  /* Date format validation */
  /*------------------------*/
  $scope.valOption = {};
  $scope.validateInput = function () {
    return $scope.valOption.validate();
  };

  /*--------------*/
  /* Get services */
  /*--------------*/
  BooksSvc.getTransactionUserList(SERVER.BooksDBConstants.LET_RECEIPT).then(
    function (resp) {
      $scope.users = resp.data;

      /*-----------------------------------------------*/
      /* Creates an array of user names formatted as   */
      /* lastName, firstName for use in the typeahead. */
      /*-----------------------------------------------*/
      for (var i = 0; i < $scope.users.length; i++) {
        $scope.users[i].fullName = [
          $scope.users[i].lastName,
          $scope.users[i].firstName
        ].join(', ');
      }

      BooksSvc.getOrganization().then(function (resp) {
        $scope.org = resp.data;
        BusyScreen.setBusy(false);
      });
    }
  );
}